var map = {
	"./drone-photography.mdx": 16,
	"./headshot.mdx": 100,
	"./photography.mdx": 101,
	"./restaurant.mdx": 895,
	"./video.mdx": 297,
	"./wedding-photography.mdx": 918
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 748;